// src/components/Header.js

import React, { useState } from 'react';
import {
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    Drawer,
    List,
    Box,
    ListItem,
    ListItemText,
    Divider,
    ListSubheader
} from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate } from 'react-router-dom';

const Header = ({ onHomeClick }) => {
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    const toggleDrawer = () => setOpen(!open);

    const handleNavigate = (path) => {
        setOpen(false);
        navigate(path);
    };

    return (
        <>
            <AppBar position="static">
                <Toolbar>
                    {/* Home-Button */}
                    <IconButton edge="start" color="inherit" onClick={onHomeClick} sx={{ mr: 2 }}>
                        <HomeIcon />
                    </IconButton>

                    {/* Titel */}
                    <Typography variant="h6" component="div" sx={{ flexGrow: 1, textAlign: 'center' }}>
                        heyRobin Vo-Pilot
                    </Typography>

                    {/* Menü-Button rechts */}
                    <IconButton edge="end" color="inherit" onClick={toggleDrawer}>
                        <MenuIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>

            {/* Seitliches Menü */}
            <Drawer anchor="right" open={open} onClose={toggleDrawer}>
                <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer}>
                    <List
                        subheader={
                            <ListSubheader component="div" id="nested-list-subheader">
                                Abrechnungs-Scanner
                            </ListSubheader>
                        }
                    >
                        <ListItem button onClick={() => handleNavigate('/scanner')}>
                            <ListItemText primary="Start / Scannen" />
                        </ListItem>
                    </List>
                    <Divider />
                    <List
                        subheader={
                            <ListSubheader component="div" id="nested-list-subheader">
                                Hilfsmittel
                            </ListSubheader>
                        }
                    >
                        <ListItem button onClick={() => handleNavigate('/vertraege')}>
                            <ListItemText primary="Verträge hinzufügen" />
                        </ListItem>
                        <ListItem button onClick={() => handleNavigate('/richtlinienAnzeigen')}>
                            <ListItemText primary="Richtlinien anzeigen " />
                        </ListItem>
                        <ListItem button onClick={() => handleNavigate('/vochecker')}>
                            <ListItemText primary="VO checken" />
                        </ListItem>
                    </List>
                    <List
                        subheader={
                            <ListSubheader component="div" id="nested-list-subheader">
                                Einstellungen
                            </ListSubheader>
                        }
                    >
                        <ListItem button onClick={() => handleNavigate('/options')}>
                            <ListItemText primary="Einstellungen" />
                        </ListItem>
                    </List>
                    <Divider />
                    <List
                        subheader={
                            <ListSubheader component="div" id="nested-list-subheader">
                                Messe
                            </ListSubheader>
                        }
                    >
                        <ListItem button onClick={() => handleNavigate('/messeDemoPage')}>
                            <ListItemText primary="MesseDemoPage NOVENTI" />
                        </ListItem>
                        <ListItem button onClick={() => handleNavigate('/messeScreenHR')}>
                            <ListItemText primary="MesseDemoPage heyRobin" />
                        </ListItem>
                    </List>
                    <Divider />
                </Box>
            </Drawer>
        </>
    );
};

export default Header;
